
type SpeedListener = (speed: number) => void;

let currentSpeed = 1.0;
const listeners = new Set<SpeedListener>();

export const playbackSpeedService = {
  getSpeed: (): number => currentSpeed,
  
  setSpeed: (speed: number) => {
    // Clamp values for safety
    const safeSpeed = Math.max(0.25, Math.min(2.0, speed));
    currentSpeed = safeSpeed;
    listeners.forEach(listener => listener(safeSpeed));
  },

  subscribe: (listener: SpeedListener): () => void => {
    listeners.add(listener);
    // Emit current value immediately on subscribe
    listener(currentSpeed);
    return () => {
      listeners.delete(listener);
    };
  }
};
